<script setup lang="ts">
import EnrichmentAiModelCard from '#operations/enrichment-ai/components/EnrichmentAiModelCard.vue'
import { ENRICHMENT_SERVICES } from '#operations/enrichment-ai/lib/types'
import PageHeader from '#shared/components/PageHeader.vue'

definePage({
  meta: { requiresAuth: true, title: 'Enrichment AI' },
})
</script>

<template>
  <PageHeader
    title="Enrichment AI"
    description="Choose the model each enrichment service runs on. Each service owns its own selection and pricing."
  />

  <div class="grid gap-4 xl:grid-cols-3">
    <EnrichmentAiModelCard
      v-for="service in ENRICHMENT_SERVICES"
      :key="service"
      :service="service"
    />
  </div>
</template>
